import './KPIBox.css';

const KPIBox = ({ label, value, sub, variant = 'default', icon }) => {
  return (
    <div className={`kpi-box kpi-box--${variant}`}>
      {icon && <span className="kpi-box__icon">{icon}</span>}
      <div className="kpi-box__body">
        <div className="kpi-box__label">{label}</div>
        <div className="kpi-box__value">{value}</div>
        {sub && <div className="kpi-box__sub">{sub}</div>}
      </div>
    </div>
  );
};

export default KPIBox;